export const safeStringify = (value: unknown): string | null => {
  try {
    return JSON.stringify(value);
  } catch (error) {
    const errorObject = error instanceof Error ? error : new Error("Unknown error");
    console.error("Failed to parse JSON:", errorObject);
    newrelic.noticeError(errorObject);
    return null;
  }
};
